import type { StepKind, StudioStage } from './studioState';

const DOING: Record<StudioStage, string> = { plan: 'Planning', voice: 'Recording the voice', build: 'Building', review: 'Working on your notes', deliver: 'Delivering' };

/** What Ivy is doing at a stage while she works, in the top bar's words: at review with no note since the build, she is finishing the video. */
export function doingWords(stage: StudioStage, notesSinceBuild: boolean): string {
  return stage === 'review' && !notesSinceBuild ? 'Finishing your video' : DOING[stage];
}

/** m:ss for the player's clock, from seconds, rounded down. */
export function formatTime(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

/** m:ss for elapsed time. */
export function clock(ms: number): string {
  const s = Math.max(0, Math.round(ms / 1000));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}

/** How each of Ivy's steps reads while it runs, once done, and if it fails. */
export const STEP_WORDS: Record<StepKind, { running: string; done: string; failed: string }> = {
  look: { running: 'Choosing the look', done: 'Chose the look', failed: "Couldn't choose the look" },
  plan: { running: 'Writing the plan', done: 'Wrote the plan', failed: "Couldn't write the plan" },
  storyboard: { running: 'Publishing the storyboard', done: 'Published the storyboard', failed: "Couldn't publish the storyboard" },
  narration: { running: 'Recording the narration', done: 'Recorded the narration', failed: "Narration didn't record" },
  assemble: { running: 'Putting the video together', done: 'Put the video together', failed: "Couldn't put the video together" },
  publish: { running: 'Making a share link', done: 'Made a share link', failed: "Couldn't make a share link" },
  check: { running: 'Watching it through', done: 'Watched it through', failed: 'The watch-through found a problem' },
  export: { running: 'Exporting the MP4', done: 'Exported the MP4', failed: "The MP4 export didn't finish" },
};
